/** @jsx jsx */
import { jsx, css } from '@emotion/react';
import type { FC } from 'react';

import Contact from '../contact';
import Devlog from '../devlog';
import Flair from '../flair';
import Layout from '../layout';
import pizza from '../assets/pizza.svg';
import coffee from '../assets/coffee.svg';
import { useSiteMetadata } from '../hooks/use-site-metadata';
import { rhythm } from '../styles/typography';
import Seo from '../seo';

const IndexPage: FC = () => {
  const siteMetadata = useSiteMetadata();

  return (
    <Layout>
      <Seo title={siteMetadata.author} description={siteMetadata.description} />

      <header data-testid="index-page-main-heading">
        <h1>
          <span
            css={css`
              margin-right: ${rhythm(0.4)};
            `}
          >
            {siteMetadata.title}
          </span>

          <Flair src={pizza} alt="" />
          <Flair src={coffee} alt="" />
        </h1>

        <p>{siteMetadata.tagline}</p>
      </header>

      <Devlog />
      <Contact />
    </Layout>
  );
};

export default IndexPage;
